import PageHeading from 'components/PageHeading/PageHeading';
import PylonForm from 'components/Forms/pylon/PylonForm';

function PylonRatePage() {
	return (
		<>
			<PageHeading
				title="Rate Lookup Tool"
				subtitleText="Find the best rates from Pylon and Mortech"
			/>
			<PylonForm />
		</>
	);
}

export default PylonRatePage;
